import { useTextsSource } from "../contexts/texts.js";
function useTexts() {
  const { passwordMismatchError } = useTextsSource();
  return { passwordMismatchError };
}
export {
  useTexts
};
//# sourceMappingURL=useTexts.js.map
